import { Helmet } from "react-helmet-async";

interface LocalBusinessSchemaProps {
  name?: string;
  address?: {
    streetAddress: string;
    addressLocality: string;
    addressRegion: string;
    postalCode: string;
    addressCountry: string;
  };
  geo?: {
    latitude: number;
    longitude: number;
  };
  telephone?: string;
  email?: string;
  priceRange?: string;
}

/**
 * Local Business Schema Markup per SEO locale
 */
const LocalBusinessSchema = ({
  name = "Fabbriche Toscane",
  address = {
    streetAddress: "Via delle Bartoline 41",
    addressLocality: "Calenzano",
    addressRegion: "Toscana",
    postalCode: "50041",
    addressCountry: "IT"
  },
  geo = {
    latitude: 43.8631,
    longitude: 11.1669
  },
  telephone = "+39 055 8878480",
  email = "contatti@fabbrichetoscane.it",
  priceRange = "€€€"
}: LocalBusinessSchemaProps) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://fabbrichetoscane.it/#organization",
    "name": name,
    "image": "https://fabbrichetoscane.it/lovable-uploads/fabbriche-toscane-logo-new.png",
    "logo": "https://fabbrichetoscane.it/lovable-uploads/fabbriche-toscane-logo-new.png",
    "url": "https://fabbrichetoscane.it",
    "telephone": telephone,
    "email": email,
    "priceRange": priceRange,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": address.streetAddress,
      "addressLocality": address.addressLocality,
      "addressRegion": address.addressRegion,
      "postalCode": address.postalCode,
      "addressCountry": address.addressCountry
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": geo.latitude,
      "longitude": geo.longitude
    },
    "areaServed": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": geo.latitude,
        "longitude": geo.longitude
      },
      "geoRadius": "100000"
    },
    "sameAs": [
      "https://www.linkedin.com/company/fabbriche-toscane/",
      "https://www.instagram.com/fabbrichetoscane/"
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "13:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "14:00",
        "closes": "18:00"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
